<template lang="pug">
v-row.ma-1.mb-6.px-2.py-4(
  :style="containerStyles",
  align="end",
  justify="space-between"
)
  v-col(cols="12", sm="9")
    Subtitle(:text="dangerZoneTitle", :fontSize="1.1", :fontWeight="900")
    TextBody(:text="dangerZoneText")
  v-col(cols="12", sm="auto")
    v-dialog(v-model="dialog", max-width="500")
      template(v-slot:activator="{ on, attrs }")
        v-btn(
          depressed,
          color="error",
          :style="dangerZoneButtonStyles",
          width="140",
          height="44",
          v-bind="attrs",
          v-on="on"
        )
          |
          | {{ dangerZoneButtonLabel }}
      v-card
        .pa-10
          Subtitle(:fontSize="1.1", :fontWeight="900")
            |
            | {{ confirmationTitle }}
          TextBody(customClass="mb-0")
            |
            | {{ confirmationText }}
        v-divider
        v-card-actions.px-10.py-4
          v-spacer
          TextButton(label="Abbrechen", @click="dialog = false") 
          TextButton(
            :label="dangerZoneButtonLabel",
            color="primary",
            @click="handleConfirmationClick"
          )
</template>

<script lang="ts">
import Vue from "vue"
import TextBody from "../UI/TextBody.vue"
import Subtitle from "../UI/Subtitle.vue"
import Button from "../UI/Button.vue"
import TextButton from "../UI/TextButton.vue"

export default Vue.extend({
  name: "DangerZone",
  components: { TextBody, Button, TextButton, Subtitle },
  props: {
    dangerZoneTitle: { type: String, required: true },
    dangerZoneText: { type: String, required: true },
    dangerZoneButtonLabel: { type: String, default: "Löschen" },
    confirmationTitle: { type: String, required: true },
    confirmationText: { type: String, required: true },
    handleConfirmation: { type: Function, required: true },
  },
  data() {
    return {
      dialog: false,
    }
  },
  computed: {
    containerStyles(): object {
      return {
        border: `1px solid ${this.$vuetify.theme.themes.light.error}`,
        borderRadius: "4px",
      }
    },
    dangerZoneButtonStyles(): object {
      return {
        fontFamily: "system-ui !important",
        letterSpacing: "0px",
        fontWeight: 900,
      }
    },
  },
  methods: {
    handleConfirmationClick(): void {
      this.handleConfirmation()
      this.dialog = false
    },
  },
})
</script>

<style lang="sass" scoped></style>
